import { EIotProvider, TIotProvider, TSupportedProviders } from '@simOn/common/providers';
import { TProviderConnectionStatus } from './auth-provider-api.model';

export enum EProviderType {
  UNKNOWN = 'UNKNOWN',
  IOT = 'IOT',
  SCAN = 'SCAN',
  INTEGRATION = 'INTEGRATION'
}

export type TProviderType = keyof typeof EProviderType;
export type TIntegrationProviderType = 'UNKNOWN' | 'MAXIMO';

export interface ISupportedProviderBase {
  logo: string;
  providerType: TProviderType;
}

export interface ISupportedIntegrationProvider extends ISupportedProviderBase {
  integrationProviderType: TIntegrationProviderType;
}

export interface IAuthorizationDeletionData {
  elementsCount: number;
}

export interface IConnectionStatus {
  status: TProviderConnectionStatus;
  lastEditorEmail: string;
}
export interface RequestedMasterDevice {
  iotProvider: TIotProvider;
  masterDeviceId: string;
  masterDeviceName: string;
}
export type SupportedProviderDisplayConfig<T extends TSupportedProviders> = {
  id: T;
  logo: string;
  isAvailable: boolean;
};

export interface IProviderInterface {
  iotProvider: TIotProvider;
  masterDeviceId: string;
}

export interface ApartmentAuthorizationConnectionRequestInterface {
  iotProvider: TIotProvider;
  masterDeviceId: string;
}

export interface TryDeleteApartmentAuthorizationResponseInterface {
  numberOfDevicesToDelete: number;
}
export interface MasterDeviceInterface {
  name: string;
  serialNumber: string;
}
export interface CentralsInterface {
  masterDevices: MasterDeviceInterface[];
  providerStatus: string;
  iotProvider: string;
}
export interface ApartmentAuthorizationConnectionsRequestInterface {
  iotProvider: EIotProvider;
  requestedMasterDevices: string[];
  rooms?: roomsAddApartmentAuthorizations[];
}

export interface roomsAddApartmentAuthorizations {
  iotProvider: TIotProvider;
  masterDeviceId: string;
  inProviderId: string;
  name: string;
}
